var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('headerCell',{attrs:{"bgColor":_vm.bgColor,"fontColor":_vm.fontColor}}),_c('div',{staticClass:"wrap"},[_c('logoCell')],1),_c('footerCell')],1)}
var staticRenderFns = []

export { render, staticRenderFns }